import { moneyFormatRules } from '@/utils/moneyFormatRules'
// import { checkOdd } from '@/utils/utils'
import { formatMoney } from '@/filters/money'
import padStart from 'lodash/padStart'
import { region } from '@/utils/utils'

/**
 * 优惠券折扣：面值/折扣
 * @param {*} data
 */
export function getCouponDiscount(data) {
  const couponType = data?.couponType
  if (!couponType) return
  // 立减券
  if (couponType === 1) {
    const { couponPrice, currency } = data || {}
    if (moneyFormatRules.SymbolInAfter) {
      return `${formatMoney(couponPrice)} ${currency}`
    }
    return `${currency} ${formatMoney(couponPrice)} `
  }
  // 折扣券
  return `${100 - data.couponDiscount}% OFF`
}

/**
 * 毫秒格式化：转为 时:分:秒
 * @param {*} millisecond
 */
export function millisecondFormat(millisecond = 0) {
  if (millisecond <= 0) return '00:00:00'
  const time = millisecond / 1000
  let h = parseInt((time / 60 / 60) % 24)
  let m = parseInt((time / 60) % 60)
  let s = parseInt(time % 60)
  const hour = padStart(h + '', 2, 0)
  const minutes = padStart(m + '', 2, 0)
  const seconds = padStart(s + '', 2, 0)
  return `${hour}:${minutes}:${seconds}`
}

/**
 * 优惠券在当前套餐是否可用
 * @param {*} data 取对应的游戏中的商品套餐，多选用逗号隔开
 * @param {*} skuId 商品id
 */
export function couponIsEnableBySku(conditionWares, skuId) {
  if (conditionWares.toLowerCase().includes('all')) return true
  const ids = conditionWares.split(',')
  return ids.includes(skuId + '')
}

/**
 * 判断优惠券是否在过期 - 为了防止用户在选择优惠券的时候刚好到过期时间，这个时候不允许用户再选择这张优惠券
 * @param {*} data 优惠券数据
 * @returns true在有效期内，false不在有效期内
 */
export function isValidTime(data) {
  const currentTime = new Date().getTime()
  // 转换为毫秒比较
  return currentTime <= data.userCouponExpireTime * 1000
}

/**
 * 判断已选中的优惠券和待选择的优惠券是否都是可以叠加的
 * 返回值：true：都是可以叠加的，false：有不可以叠加的优惠券
 * @param {*} coupons 优惠券列表
 * @param {*} data 当前选择的优惠券
 */
export function checkSelectedIsOverlay(coupons = [], data = {}) {
  const { conditionOverlay } = data
  // 待选择的优惠券是否可以叠加
  if (!conditionOverlay) return false
  const selctedCantOverlay = coupons.filter(
    (item) => item.selected && !item.conditionOverlay
  )
  // 筛选选中的优惠券中有不可以叠加的，则返回false，否则返回true
  return selctedCantOverlay.length === 0
}

/**
 * 改变优惠券的选中状态 - 仅只用于已选择和未选择的优惠券都是可以叠加的优惠券情况，目前只用于取消选中
 * 未选中 => 选中
 * 选中 => 未选中
 * @param {*} coupons 优惠券列表
 * @param {*} data 当前选择的优惠券
 */
export function switchSelectedCoupon(coupons = [], data = {}) {
  const { userCouponId } = data
  return coupons.map((item) => {
    if (userCouponId === item.userCouponId) {
      item.selected = !item.selected
    }
    return item
  })
}

/**
 * 更改优惠券的选择状态
 * @param {*} coupons 优惠券列表
 * @param {*} data 当前选择的优惠券
 */
export function updateCouponSelected(coupons = [], data = {}) {
  const { userCouponId, conditionOverlay } = data
  // conditionOverlay	必填；是否支持叠加使用 0 不支持，1支持
  if (conditionOverlay) {
    // 支持叠加 - 同时取消已选中的不支持叠加的
    return coupons.map((item) => {
      if (userCouponId === item.userCouponId) {
        item.selected = !item.selected
      } else {
        item.selected = item.conditionOverlay ? item.selected : false
      }
      return item
    })
  }
  // 不支持叠加
  // 当勾选不支持叠加使用的优惠券时，默认将其他优惠券置未勾选状态，同时不支持叠加使用的优惠券上展示“不支持叠加使用”文案。
  return coupons.map((item) => {
    item.selected = userCouponId === item.userCouponId ? !item.selected : false
    return item
  })
}

/**
 * 获取花括号中的内容，不好括花括号
 * @param {*} data 字符串
 */
export function getBracketsData(data = '') {
  const dataArray = data.match(/\{(.+?)\}/g)
  if (dataArray && dataArray.length > 0) {
    return dataArray[0].slice(1, -1)
  }
  return ''
}

/**
 * 判断是否展示新版优惠券
 * 生效国家ru-mlbb+pubgm, kicoinId奇数使用新版，偶数使用老版本
 * 如果拿不到kicoinId（即未登录状态），使用老版本
 * @param {*} gameName 游戏名称
 * @param {*} userInfo 用户信息
 * @returns true新版，false老版本
 */
export function isNewCoupon(gameName) {
  let games = ['pubgm', 'mobile-legends']
  if (isNewGenshin(gameName)) {
    games = [...games, 'genshin']
  }

  return games.includes(gameName)
}

// 是否是新版的原神：ru-原神，支持随时下线（因此通过abtest控制）
export function isNewGenshin(gameName) {
  const country = region()
  // const abtest_genshin_discount = window.abtest_genshin_discount
  const abtest_genshin_discount = true
  return gameName === 'genshin' && country === 'ru' && abtest_genshin_discount
}

/**
 * 格式化金额格式
 * @param {Number} value 价格
 */

export function amountFormat(value) {
  if (isNaN(value) || value <= 0) {
    return 0
  } else if (value < 1) {
    return (((value * 100) / 100 || 0) * 1).toFixed(2)
  } else {
    return ((value || 0) * 1).toFixed(2)
  }
}
